module.exports = __webpack_public_path__ + "img/icon-live.a28e9ba1.svg";